export const mapFaqs = (data) => {
  if (!data) return null;
  const faqs = {};
  data.forEach((faq, index) => {
    const { question, answer, faqCategories, faqOrder } = faq;
    // Use faqOrder as ID or generate one based on index
    const uuid = faq.id || `faq-${faqOrder || index + 1}`;

    // Parse categories - they come as array with comma-separated string
    let parsedCategories = [];
    let primaryCategory = null;

    if (faqCategories && faqCategories.length > 0 && faqCategories[0]) {
      // Split the comma-separated string and trim whitespace
      parsedCategories = faqCategories[0]
        .split(",")
        .map((cat) => cat.trim())
        .filter((cat) => cat);
      primaryCategory = parsedCategories[0] || null;
    }

    faqs[uuid] = {
      uuid,
      question: question,
      answer: answer,
      category: primaryCategory,
      // Store all parsed categories for future use
      categories: parsedCategories,
      order: faqOrder || index + 1,
    };
  });
  return faqs;
};

export const mapFaqsIds = (data) => {
  if (!data) return null;
  const faqsIds = [];
  data.forEach((faq, index) => {
    // Use faqOrder as ID or generate one based on index
    const uuid = faq.id || `faq-${faq.faqOrder || index + 1}`;
    faqsIds.push(uuid);
  });
  // Sort by the FAQ order number
  return faqsIds.sort((a, b) => {
    const orderA = parseInt(a.split("-")[1]) || 999;
    const orderB = parseInt(b.split("-")[1]) || 999;
    return orderA - orderB;
  });
};

export const mapFaqsCategories = (data) => {
  if (!data) return {};

  const faqsCategories = {};
  const categorySet = new Set();

  // Extract categories from FAQs themselves
  data.forEach((faq) => {
    const faqCategoriesArray = faq.faqCategories || [];

    // Handle comma-separated categories within the first array element
    if (faqCategoriesArray.length > 0 && faqCategoriesArray[0]) {
      const categories = faqCategoriesArray[0]
        .split(",")
        .map((cat) => cat.trim())
        .filter((cat) => cat);

      categories.forEach((categoryName) => {
        if (categoryName && !categorySet.has(categoryName)) {
          categorySet.add(categoryName);
          // Use category name as both ID and name for simplicity
          faqsCategories[categoryName] = {
            name: categoryName,
            id: categoryName,
          };
        }
      });
    }
  });

  return faqsCategories;
};

export const mapFaqsCategoriesIds = (data) => {
  if (!data) return [];

  const categorySet = new Set();

  // Extract unique category IDs from FAQs
  data.forEach((faq) => {
    const faqCategoriesArray = faq.faqCategories || [];

    // Handle comma-separated categories within the first array element
    if (faqCategoriesArray.length > 0 && faqCategoriesArray[0]) {
      const categories = faqCategoriesArray[0]
        .split(",")
        .map((cat) => cat.trim())
        .filter((cat) => cat);

      categories.forEach((categoryName) => {
        if (categoryName) {
          categorySet.add(categoryName);
        }
      });
    }
  });

  // Return sorted array of category IDs
  return Array.from(categorySet).sort();
};
